import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "../SideBar.module.css";

import icon from "../imgs/icons_shows.png";

import { bringShowsToFront } from "../../../redux/modules/content/shows";

import { incrementTopZ } from "../../../redux/modules/ui";

/**
 * @author  Francis Goodship and Conan Lai
 * @description takes in height/width prop from Icons component, which calculates size based
 * on number of icons
 */

class ShowsIcon extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    if (this.props.isMobile) {
      this.props.closeAll();
    }
    const newZ = this.props.topZIndex + 1;
    this.props.bringShowsToFront(newZ);
    this.props.incrementTopZ();
  }

  render() {
    return (
      <div
        className={styles.element}
        style={{
          height: this.props.height ? `${this.props.height}%` : null,
          width: this.props.width ? `${this.props.width}%` : null,
        }}
        onClick={this.handleClick}
        data-tip="shows"
      >
        <div className={styles.imgwrapper}>
          <img src={icon} />
        </div>
      </div>
    );
  }
}

ShowsIcon.propTypes = {
  isMobile: PropTypes.bool,
  closeAll: PropTypes.func,
  height: PropTypes.number,
  width: PropTypes.number,
  bringShowsToFront: PropTypes.func,
  incrementTopZ: PropTypes.func,
  topZIndex: PropTypes.number,
};

const mapPropsToState = (state) => {
  return {
    z: state._shows.z,
    topZIndex: state._ui.topZIndex,
  };
};

const ConnectedShowsIcon = connect(mapPropsToState, {
  bringShowsToFront,
  incrementTopZ,
})(ShowsIcon);

export default ConnectedShowsIcon;
